<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Sports & Cultural Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Sports & Cultural Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name of the member</th>
                <th>Role in Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Dr. Prajakta Tembhurne</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Prof. Ashwini Kamble</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Ms. Tejal Pawar</td>
                <td>Student Representative (Sports)</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Mr. Harsh Dayma</td>
                <td>Student Representative (Sports)</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Mr. Aatish Walmiki</td>
                <td>Student Representative (Sports)</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Ms. Nakshatra Mahajan</td>
                <td>Student Representative (Cultural)</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Ms. Deepali Sahu</td>
                <td>Student Representative (Cultural)</td>
              </tr>
            </tbody>
          </table>
          <!-- <table class="table table-bordered table-striped table--4">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name of the member</th>
                        <th>Role in Committee</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Mr. Nitin Choudhari</td>
                        <td>Chairman</td>
                      </tr>
                      <tr>
                        <td>2 </td>
                        <td>Prof.Mohini Pardeshi</td>
                        <td>Teaching Representative</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Ms. Tejal Pawar</td>
                        <td>Student Representative</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Mr. Dhanajay Patel</td>
                        <td>Student Representative</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Ms. Jidnyasa Athawale</td>
                        <td>Student Representative</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Ms. Harshada Darekar</td>
                        <td>Student Representative</td>
                      </tr>
                    </tbody>
                  </table> -->
        </div>
      </div>
    </div>
  </div>
</section>
